import { PermissionFeature } from '@shared/const';
import * as Icons from '@ui/components/icons';
import { Routes } from '@shared/enums';

interface PermissionRoute {
  icon: (typeof Icons)[keyof typeof Icons];
  permission: PermissionFeature;
  title: string;
  url: Routes;
}

/**
 * Menu main routes
 */

export const MENU_ROUTES: PermissionRoute[] = [
  {
    title: 'NAVBAR.DASHBOARD',
    permission: 'DASHBOARD',
    url: Routes.DASHBOARD,
    icon: Icons.Home,
  },
  {
    title: 'NAVBAR.EMPLOYEES',
    permission: 'EMPLOYEES',
    url: Routes.EMPLOYEES,
    icon: Icons.Users,
  },
  {
    title: 'NAVBAR.EMPLOYEE_PROFILES',
    permission: 'EMPLOYEES_PROFILE',
    url: Routes.EMPLOYEE_PROFILES,
    icon: Icons.User,
  },
  {
    title: 'NAVBAR.VEHICLES',
    permission: 'VEHICLES',
    url: Routes.VEHICLES,
    icon: Icons.Car,
  },
  {
    title: 'NAVBAR.PARKING_SPOTS',
    permission: 'PARKINGS',
    url: Routes.PARKING_SPOTS,
    icon: Icons.Parking,
  },
  {
    title: 'NAVBAR.COST_CENTER',
    permission: 'COST_CENTER',
    url: Routes.COST_CENTER,
    icon: Icons.Pay,
  },
  {
    title: 'NAVBAR.SUBSCRIPTIONS',
    permission: 'SUBSCRIPTIONS',
    url: Routes.SUBSCRIPTION,
    icon: Icons.Wallet,
  },
  {
    title: 'NAVBAR.FILES_REPORTS',
    permission: 'REPORTS_FILES',
    url: Routes.FILES_REPORTS,
    icon: Icons.Report,
  },
  {
    title: 'NAVBAR.HELP',
    permission: 'HELP',
    url: Routes.HELP,
    icon: Icons.Contact,
  },
];
